export const CREATE_STORE_ACTIONS = {
  REQUESTED: 'create/store/required',
  SUCCEEDED: 'create/store/succeeded',
  FAILED: 'create/store/failed',
};

export const CREATE_MARKET_ACTIONS = {
  REQUESTED: 'create/market/required',
  SUCCEEDED: 'create/market/succeeded',
  FAILED: 'create/market/failed',
};

export const createStoreRequested = (store: any, file: any) => ({
  type: CREATE_STORE_ACTIONS.REQUESTED,
  payload: { store, file },
});

export const createStoreSucceeded = () => ({
  type: CREATE_STORE_ACTIONS.SUCCEEDED,
});

export const createStoreFailed = (error: any) => ({
  error,
  type: CREATE_STORE_ACTIONS.FAILED,
});

export const createMarketRequested = (market: any) => ({
  type: CREATE_MARKET_ACTIONS.REQUESTED,
  payload: { market },
});

export const createMarketSucceeded = () => ({
  type: CREATE_MARKET_ACTIONS.SUCCEEDED,
});

export const createMarketFailed = (error: any) => ({
  error,
  type: CREATE_MARKET_ACTIONS.FAILED,
});



// WEBPACK FOOTER //
// ./src/scenes/CreateStore/services/actions.ts